// src/belediye/components/AltBar.js
//
// FAZ-90 — ALT NAVİGASYON BARI (yalnız TELEFON).
//
// Tablette kalıcı ikon rayı var (FAZ-87), masaüstünde sidebar. Bar yalnız
// telefonda çizilir; katman kontrolünü kendi içinde yapar, çağıran taraf
// koşul yazmaz.
//
// Yuvalar rol string'inden DEĞİL izinden türer — bkz. ../altbar.js (K-7).
// Merkez sohbet düğmesi bardan taşkındır ve BAĞLAMA DUYARLIDIR (K-6):
// talep detayındayken altına döner ve o talebin sohbetini açar.

import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import usePermissions from "../hooks/usePermissions";
import useKatman from "../hooks/useKatman";
import { selectEnabledModules } from "../redux/slices/authzSlice";
import {
  gorunurYuvalar,
  sohbetAcikMi,
  merkezKonumu,
  yuvaAktifMi,
  GOREV_SOHBET_EVENT,
} from "../altbar";
import { AltBarIkon, ChatBarIcon } from "./icons/appIcons";
import { UNREAD_EVENT } from "./mesajlasma/ChatDock";
import "./AltBar.css";

// Talep detay rotası — merkez düğme burada bağlam değiştirir.
const GOREV_DETAY = /^\/yonetim\/(?:[^/]+\/)?gorevler\/[^/]+$/;

// GorevDetayPage bu olayı dinleyip o talebin sohbetine gider.
// Neden olay: sayfa ile bar farklı ağaçlarda; sistemin sohbet açma dili
// zaten olay tabanlı (mesajlasma:toggle, mesajlasma:open). Barın hangi
// conversation olduğunu bilmesi de mümkün değil — o bilgi sayfada.
//
// FAZ-99 / Y-5: adın kendisi `../altbar`a taşındı — tablette ChatDock da aynı
// olayı yayınlıyor ve buradan içe aktarması dairesel bağımlılık olurdu.
// Buradaki yeniden dışa aktarım mevcut çağrı yerlerini (GorevDetayPage) korur.
export { GOREV_SOHBET_EVENT } from "../altbar";

// FAZ-94 madde 19 — "SON KABUK ROTASI" HAFIZASI.
//
// Kullanıcı: "sayfa değişince ya da geri gelince, en son hangi alt navbar
// sayfasındaysan oraya gidilecek mantıkta olacak."
//
// `navigate(-1)` çoğu durumda bunu verir; ama sohbete BİLDİRİMDEN ya da
// SMS'ten gelindiyse geçmiş boştur ve geri tuşu kullanıcıyı uygulamanın
// dışına atar. O boşluğu bu hafıza doldurur.
//
// Neden `sessionStorage`: sekme ömrüyle sınırlı olmalı. `localStorage`
// olsaydı iki hafta önceki rota bugün geri tuşuna cevap verirdi.
// FAZ-94 madde 23.2 — balonun öğrenme sayacı.
// İki kez bu yoldan sohbet açıldıysa balon bir daha hiç çıkmaz.
// `localStorage` (sekme değil KİŞİ öğrenir) — `sessionStorage` olsaydı her
// yeni sekmede baştan anlatmaya başlardık.
const BALON_LS = "talep.sohbet.ogrenildi";
const BALON_TAVAN = 2;
export const balonOgrenildi = () => {
  try {
    return (Number(localStorage.getItem(BALON_LS)) || 0) >= BALON_TAVAN;
  } catch {
    return false;
  }
};
const balonOgrenildiArtir = () => {
  try {
    const n = Number(localStorage.getItem(BALON_LS)) || 0;
    localStorage.setItem(BALON_LS, String(n + 1));
  } catch {
    /* özel sekme / kota — balon her girişte çıkar, akış bozulmaz */
  }
};

const SON_ROTA_LS = "kabuk.sonRota";
export const sonKabukRotasi = () => {
  try {
    return sessionStorage.getItem(SON_ROTA_LS) || null;
  } catch {
    return null;
  }
};

export default function AltBar({ cikisYap }) {
  const katmanAdi = useKatman();
  const { permissions, uiProfile, can } = usePermissions();
  const navigate = useNavigate();
  const enabledModules = useSelector(selectEnabledModules);
  const { pathname } = useLocation();

  // FAZ-67 dersi: menü boolean'ları AYRI AYRI tutulmaz, TEK state'te.
  // FAZ-92'de ikinci menü (Talepler sorusu) gelince bu karşılığını verdi.
  // null | "profil" | "talepler" | "sohbet"
  const [acikMenu, setAcikMenu] = React.useState(null);

  /* FAZ-97/2 — MENÜ, ÇIKTIĞI DÜĞMENİN ALTINDAN AÇILIR.

     Kullanıcı (2026-08-01): "talep atayan ve talep alan kişilerde tıklayınca
     çıkan [menü] ortadaki sohbet kısmından geliyor."

     TEŞHİS: `.altbar-menu--orta` `left: 50%` ile ekranın ORTASINA
     yerleşiyordu — orası merkez sohbet düğmesinin yeri. Talepler yuvası ise
     barda başka bir hücrede. Yani menü, basılan düğmeyi değil komşusunu
     işaret ediyordu. Madde 9'un ("popup nereden çıktığını belli etsin")
     tam da kapatması gereken kusur.

     Çözüm: tetiğin ekran üzerindeki MERKEZİ ölçülür; menü ona göre
     konumlanır ve ok da o noktayı gösterir. Ölçüm tıklama anında yapılır —
     yuva sayısı role göre değiştiği için sabit bir yüzde yazılamaz. */
  const [cipaX, setCipaX] = React.useState(null);
  const menuRef = React.useRef(null);

  const menuAc = (ad, e) => {
    const r = e?.currentTarget?.getBoundingClientRect?.();
    if (r) setCipaX(r.left + r.width / 2);
    setAcikMenu((a) => (a === ad ? null : ad));
  };

  React.useLayoutEffect(() => {
    const el = menuRef.current;
    if (!acikMenu || !el || cipaX == null) return;
    const w = el.offsetWidth;
    const vw = window.innerWidth || w;
    const KENAR = 8;
    // Menü tetiğe ortalanır ama ekrandan taşmaz.
    const sol = Math.min(Math.max(cipaX - w / 2, KENAR), vw - w - KENAR);
    el.style.left = `${sol}px`;
    /* Menü kenara dayandığında ok tetiğin üstünde KALIR: okun yeri menüye
       değil tetiğe bağlı. Uçlarda köşeden taşmasın diye 16px pay. */
    const okX = Math.min(Math.max(cipaX - sol, 16), Math.max(w - 16, 16));
    el.style.setProperty("--pop-ok-x", `${okX}px`);
  }, [acikMenu, cipaX]);

  // Okunmamış sayısı ChatDock'un yaydığı olaydan okunur — ikinci bir
  // sayaç isteği atılmaz (FAZ-51: tek sayaç).
  const [okunmamis, setOkunmamis] = React.useState(0);
  React.useEffect(() => {
    const on = (e) => setOkunmamis(Number(e?.detail?.unread) || 0);
    window.addEventListener(UNREAD_EVENT, on);
    return () => window.removeEventListener(UNREAD_EVENT, on);
  }, []);

  // Rota değişince menü kapanır — açık menüyle sayfa değişmesi kafa karıştırır.
  React.useEffect(() => {
    setAcikMenu(null);
  }, [pathname]);

  /* FAZ-94 madde 23.2 — YÖNLENDİREN BALON.
     Talep detayına ilk girişlerde merkez düğmeyi işaret eden minik bir balon
     ("Bu talebin sohbeti"). Keşif yardımı olduğu için ÖĞRENİLİNCE SUSAR:
     bu yoldan sohbet iki kez açıldıysa bir daha hiç çıkmaz. Sayaç
     localStorage'da — oturum değil, kişi öğreniyor. */
  const [balon, setBalon] = React.useState(false);
  React.useEffect(() => {
    if (!GOREV_DETAY.test(pathname) || balonOgrenildi()) {
      setBalon(false);
      return undefined;
    }
    // Girişten hemen sonra değil: sayfa otursun, göz önce içeriği görsün.
    const gel = setTimeout(() => setBalon(true), 600);
    // FAZ-97 madde 6 — kullanıcı "çok erken gidiyor" dedi: 4 → 9 saniye.
    // Balon zaten ömür boyu EN FAZLA İKİ KEZ görünüyor; uzun kalması
    // gürültü üretmez, kısa kalması ise mesajı hiç iletmiyordu.
    const git = setTimeout(() => setBalon(false), 9600);
    return () => {
      clearTimeout(gel);
      clearTimeout(git);
      setBalon(false);
    };
  }, [pathname]);

  /* FAZ-94 madde 19 — kabuk rotası hatırlanır. Sohbet rotaları HARİÇ:
     hatırlanması gereken "sohbete girmeden önce neredeydim" bilgisidir. */
  React.useEffect(() => {
    if (pathname.startsWith("/yonetim/sohbet")) return;
    try {
      sessionStorage.setItem(SON_ROTA_LS, pathname);
    } catch {
      /* özel sekme / kota — hafıza yok, geri yine listeye düşer */
    }
  }, [pathname]);

  // Bar YALNIZ telefonda.
  if (katmanAdi !== "telefon") return null;

  const yuvalar = gorunurYuvalar(permissions, { enabledModules, uiProfile });
  const merkezVar = sohbetAcikMi(enabledModules);
  const merkezIdx = merkezVar ? merkezKonumu(yuvalar.length) : -1;

  /* FAZ-92 — TALEPLER YUVASI: HER SEFERİNDE SOR.
     Kullanıcı (2026-08-01): "oraya tıklanınca her seferinde hangi sayfaya
     geçmek istiyorsun şeklinde sorulsun."
     Yalnız İKİSİ DE olan kişide sorulur; tek taraflı rolde soru anlamsız
     olurdu ve yuva doğrudan kendi sayfasına gider. */
  const verir = can("tasks.view_created");
  const alir = can("tasks.view_assigned") || can("tasks.view_unit_pool");
  const talepSorulur = verir && alir;

  const gorevBaglami = GOREV_DETAY.test(pathname);
  const balonGorunur = gorevBaglami && balon;
  /* FAZ-94 madde 7 — MERKEZ YUVANIN AKTİFLİĞİ ARTIK OLUŞUYOR.
     Sohbet telefonda gerçek bir rota olduğu için "buradayım" bilgisi
     pathname'den okunuyor; FAZ-93'te hazırlanan `.altbar-merkez.etkin`
     stili buraya bağlanıyor. */
  const sohbetteyiz = pathname.startsWith("/yonetim/sohbet");
  /* FAZ-97 madde 5 — TALEP DETAYINDA MERKEZ DÜĞME SORAR.

     Sorun: düğme talep detayında bağlam değiştirip o talebin sohbetini
     açıyordu (K-6/K-2) ve GENEL sohbete gitmenin yolu kalmıyordu — kullanıcı
     önce başka bir sayfaya gidip sonra sohbete girmek zorundaydı.

     Elenenler: köşe düğmesini geri getirmek (kullanıcı kaldırttı), uzun
     basma (mobilde keşfedilmez), geri okuna popup (en sık işi ikiye çıkarır),
     düğmeyi hep genel sohbet yapmak (K-2'yi geri alırdı).

     Seçilen: kullanıcının KENDİ kurduğu desen. Talepler yuvası da "her
     seferinde sorulsun" diye soruyor (FAZ-92, kullanıcı kararı). İki hedef
     de her zaman erişilebilir ve düğmenin anlamı ekrana göre değişmiyor.
     Bedeli açık: talep sohbeti bir dokunuş uzaklaştı; menüde İLK sırada. */
  const merkezAc = (e) => {
    if (gorevBaglami) {
      setBalon(false);
      menuAc("sohbet", e);
      return;
    }
    /* FAZ-94 — telefonda pencere DEĞİL rota. `toggleChat()` köprüsü tablet
       ve masaüstünde aynen duruyor; burası zaten yalnız telefonda çiziliyor. */
    navigate("/yonetim/sohbet");
  };

  /** Menüden "bu talebin sohbeti" seçildi — balonun görevi bitti. */
  const talepSohbetiAc = () => {
    setAcikMenu(null);
    balonOgrenildiArtir();
    window.dispatchEvent(new CustomEvent(GOREV_SOHBET_EVENT));
  };

  const merkez = (
    <button
      key="__merkez__"
      type="button"
      className={[
        "altbar-merkez",
        gorevBaglami ? "altbar-merkez--gorev" : "",
        !gorevBaglami && sohbetteyiz ? "etkin" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={merkezAc}
      aria-label={gorevBaglami ? "Sohbet seç" : "Sohbet"}
      aria-haspopup={gorevBaglami ? "menu" : undefined}
      aria-expanded={gorevBaglami ? acikMenu === "sohbet" : undefined}
      aria-current={!gorevBaglami && sohbetteyiz ? "page" : undefined}
    >
      {/* Balon düğmenin İÇİNDE: dokunmak da sohbeti açar (ekran okuyucu
          kullanıcısı için kısayol). `role="status"` + `aria-live="polite"`
          bir kez okunur, odak çalmaz. */}
      {balonGorunur && (
        <span className="altbar-balon" role="status" aria-live="polite">
          Bu talebin sohbeti
        </span>
      )}
      <span className="altbar-merkez-kabarcik">
        <ChatBarIcon className="altbar-merkez-ikon" />
      </span>
      <span className="altbar-etiket">
        {gorevBaglami ? "Talep Sohbeti" : "Sohbet"}
      </span>
      {/* Sayaç yalnız GENEL sohbette; talep sohbetinde anlamsız olurdu. */}
      {!gorevBaglami && okunmamis > 0 && (
        <span className="altbar-merkez-sayac" aria-hidden="true">
          {okunmamis > 9 ? "9+" : okunmamis}
        </span>
      )}
    </button>
  );

  const ogeler = [];
  yuvalar.forEach((y, i) => {
    if (i === merkezIdx) ogeler.push(merkez);

    // Talepler yuvası: iki tarafı da olan kişide rotaya gitmez, SORAR.
    if (y.key === "talepler" && talepSorulur) {
      ogeler.push(
        <button
          key={y.key}
          type="button"
          className={["altbar-yuva", acikMenu === "talepler" ? "etkin" : ""]
            .filter(Boolean)
            .join(" ")}
          onClick={(e) => menuAc("talepler", e)}
          aria-haspopup="menu"
          aria-expanded={acikMenu === "talepler" ? "true" : "false"}
          data-yuva="talepler"
        >
          <AltBarIkon
            ad={y.icon}
            className="altbar-ikon"
            dolu={acikMenu === "talepler"}
          />
          <span className="altbar-etiket">{y.label}</span>
        </button>,
      );
      return;
    }

    // Profil yuvası ROTAYA GİTMEZ — menü açar (Profil / Çıkış yap).
    if (y.menu) {
      ogeler.push(
        <button
          key={y.key}
          type="button"
          className={["altbar-yuva", acikMenu === "profil" ? "etkin" : ""]
            .filter(Boolean)
            .join(" ")}
          onClick={(e) => menuAc("profil", e)}
          aria-haspopup="menu"
          aria-expanded={acikMenu === "profil" ? "true" : "false"}
          data-yuva="profil"
        >
          <AltBarIkon
            ad={y.icon}
            className="altbar-ikon"
            dolu={acikMenu === "profil"}
          />
          <span className="altbar-etiket">{y.label}</span>
        </button>,
      );
      return;
    }

    /* FAZ-97 madde 1 — aktiflik NavLink'in `isActive`inden DEĞİL, yuvanın
       kendi rota ailesinden okunur. `isActive` tam yol eşleşmesi yapıyor ve
       Yönlendirilenler gibi KARDEŞ rotalarda hiçbir yuvayı aktif saymıyordu. */
    const aktif = yuvaAktifMi(y, pathname);
    ogeler.push(
      <NavLink
        key={y.key}
        to={y.to}
        className={["altbar-yuva", aktif ? "etkin" : ""]
          .filter(Boolean)
          .join(" ")}
        aria-current={aktif ? "page" : undefined}
      >
        <AltBarIkon ad={y.icon} className="altbar-ikon" dolu={aktif} />
        <span className="altbar-etiket">{y.label}</span>
      </NavLink>,
    );
  });
  if (merkezIdx === yuvalar.length) ogeler.push(merkez);

  return (
    <>
      {/* FAZ-97 madde 5 — TALEP DETAYINDA SOHBET SEÇİMİ.
          Talepler yuvasının sorduğu soruyla aynı desen, aynı bileşen. */}
      {acikMenu === "sohbet" && (
        <>
          <div
            className="altbar-perde"
            onClick={() => setAcikMenu(null)}
            aria-hidden="true"
          />
          <div
            ref={menuRef}
            className="altbar-menu altbar-menu--cipa pop-ok"
            data-ok="alt"
            role="menu"
          >
            <div className="altbar-menu-bas">Hangi sohbet?</div>
            {/* İLK sıra varsayılan iş: göz önce onu görür. */}
            <button
              type="button"
              role="menuitem"
              className="altbar-menu--vurgu"
              onClick={talepSohbetiAc}
            >
              <AltBarIkon ad="gorev" className="altbar-menu-ikon" />
              <span>Bu talebin sohbeti</span>
            </button>
            <button
              type="button"
              role="menuitem"
              onClick={() => {
                setAcikMenu(null);
                navigate("/yonetim/sohbet");
              }}
            >
              <ChatBarIcon className="altbar-menu-ikon" />
              <span>Tüm sohbetler</span>
            </button>
          </div>
        </>
      )}

      {/* Menüler barın ÜSTÜNDE açılır, perdeyle kapanır. */}
      {acikMenu === "talepler" && (
        <>
          <div
            className="altbar-perde"
            onClick={() => setAcikMenu(null)}
            aria-hidden="true"
          />
          <div
            ref={menuRef}
            className="altbar-menu altbar-menu--cipa pop-ok"
            data-ok="alt"
            role="menu"
          >
            <div className="altbar-menu-bas">Hangi listeye geçelim?</div>
            <button
              type="button"
              role="menuitem"
              onClick={() => {
                setAcikMenu(null);
                navigate("/yonetim/gorevlerim");
              }}
            >
              <AltBarIkon ad="gorev" className="altbar-menu-ikon" />
              <span>Bana Gelenler</span>
            </button>
            <button
              type="button"
              role="menuitem"
              onClick={() => {
                setAcikMenu(null);
                navigate("/yonetim/gorev-ata");
              }}
            >
              <AltBarIkon ad="arti" className="altbar-menu-ikon" />
              <span>Verdiklerim</span>
            </button>
          </div>
        </>
      )}

      {acikMenu === "profil" && (
        <>
          <div
            className="altbar-perde"
            onClick={() => setAcikMenu(null)}
            aria-hidden="true"
          />
          <div
            ref={menuRef}
            className="altbar-menu altbar-menu--cipa pop-ok"
            data-ok="alt"
            role="menu"
          >
            <NavLink
              to="/yonetim/profil"
              role="menuitem"
              onClick={() => setAcikMenu(null)}
            >
              <AltBarIkon ad="kisi" className="altbar-menu-ikon" />
              <span>Profil</span>
            </NavLink>
            <hr />
            <button
              type="button"
              role="menuitem"
              className="cikis"
              onClick={cikisYap}
            >
              <AltBarIkon ad="cikis" className="altbar-menu-ikon" />
              <span>Çıkış yap</span>
            </button>
          </div>
        </>
      )}

      <nav
        className="altbar"
        aria-label="Ana gezinme"
        data-yuva={yuvalar.length}
      >
        {ogeler}
      </nav>
    </>
  );
}
